import React from 'react'
import { NavLink } from 'react-router-dom'
import './footer.css'

const FooterElement = () => (
    <div className="container container_gray footer">
        <div className="footer_container">
            <NavLink to="/"><img src="/images/logo/logo_bgb.png" width="180px" alt="logo_footer" /></NavLink>
            <div className="footer_voice">
                <a href="mailto:info@matterflies.com">CONTACT US</a>
            </div>
            <div className="footer_voice">
                <NavLink to="/privacy">PRIVACY POLICIES</NavLink>
            </div>
            <div className="footer_voice footer_copyright">
                © 2023 Matterflies. All Rights Reserved. Matterflies and the Matterflies logo are trademarks of Matterflies company.
            </div>
        </div>
    </div>
)

export { FooterElement }
